import { Component, input, inject, effect, output, computed } from '@angular/core';

import { CommonModule } from '@angular/common';

import { combineLatest, BehaviorSubject, map } from 'rxjs';

import { TeamLogoLookupPipe } from '../shared/team-logo-lookup.pipe';
import { TimespanMsPipe, TimespanShortPipe } from '../shared/time-span.pipe';

import { ISessionEntry } from './IRaceTiming';
import { RaceSessionService } from './race-session.service';
import { TimingTowerService, ToggleAction } from './timing-tower.service';

@Component({
  selector: 'vb-lxp-timing-tower',
  imports: [CommonModule, TeamLogoLookupPipe, TimespanMsPipe, TimespanShortPipe],
  templateUrl: './timing-tower.component.html',
  styleUrl: './timing-tower.component.css',
})
export class TimingTowerComponent {
  public enableMoreColumns = input(false);
  public activeClass = input('');
  public activeNumberClass = input('');
  public selectedClasses = input<string[]>([]);

  public selectionAdded = output<ISessionEntry>();
  public selectionRemoved = output<ISessionEntry>();

  public raceSessionService = inject(RaceSessionService);
  public timingTowerService = inject(TimingTowerService);

  protected readonly selectedClassSubject$ = new BehaviorSubject<string[]>([]);

  public entries = computed(() => this.raceSessionService.raceTeamsPosition());
  teams = computed(() => {
    const selectedClasses = this.selectedClasses();
    if (!this.entries()) return [];

    console.log(this.entries());
    return this.entries()
      .map((entry) => {
        if (!entry?.activeStanding) {
          return;
        }

        return {
          ...entry,
          positionChangeState:
            entry.activeStanding.positionChange > 0
              ? 'up'
              : entry.activeStanding.positionChange < 0
                ? 'down'
                : 'neutral',
          flashState: entry.activeStanding.positionChange !== 0 ? 'active' : 'inactive',
        } as any;
      })
      .filter((entry) => {
        return entry && (selectedClasses.length === 0 || selectedClasses.includes(entry.class));
      });
  });

  constructor() {
    effect(() => {
      this.raceSessionService.raceTeamsPosition();
      this.selectedClassSubject$.next(this.selectedClasses());
    });
  }

  public toggleTeamSelection(team: ISessionEntry) {
    if (!team.playback?.url) {
      return;
    }
    const action = this.timingTowerService.toggleActive(team.number);
    switch (action) {
      case ToggleAction.ADDED: {
        this.selectionAdded.emit(team);
        break;
      }
      case ToggleAction.REMOVED: {
        this.selectionRemoved.emit(team);
        break;
      }
    }
  }

  public trackByFn(index: number, item: any): string {
    return item.number; // assuming unique team number
  }
}
